import { render, staticRenderFns } from "./Extra.vue?vue&type=template&id=41556888&scoped=true"
import script from "./Extra.vue?vue&type=script&lang=js"
export * from "./Extra.vue?vue&type=script&lang=js"
import style0 from "./Extra.vue?vue&type=style&index=0&id=41556888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41556888",
  null
  
)

export default component.exports